import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useShopStore = defineStore('shopms', () => {
    // 状态：直接用 ref/reactive 声明
    const shopId = useStorage('shopId',2)
    // 方法：直接声明函数
    const setadmin = (value) => {
        shopId.value = value
    }
    return { shopId, setadmin }
})